import { render, staticRenderFns } from "./PropertyContactForm.vue?vue&type=template&id=4c38ef24&scoped=true&"
import script from "./PropertyContactForm.vue?vue&type=script&lang=js&"
export * from "./PropertyContactForm.vue?vue&type=script&lang=js&"
import style0 from "./PropertyContactForm.vue?vue&type=style&index=0&id=4c38ef24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c38ef24",
  null
  
)

export default component.exports